var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOff(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48.107 50",
    enableBackground: "new 0 0 48.107 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E00505",
    d: "M24.048,23.619c2.375,0,4.346-1.921,4.346-4.291V4.294c0-2.371-1.97-4.294-4.346-4.294 c-2.368,0-4.341,1.923-4.341,4.294v15.034C19.706,21.697,21.68,23.619,24.048,23.619L24.048,23.619z M24.048,23.619"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E00505",
    d: "M33.335,3.715c-0.54-0.222-1.149-0.162-1.636,0.16c-0.484,0.321-0.777,0.864-0.777,1.447v5.703 c0,0.627,0.337,1.199,0.878,1.509c4.67,2.684,7.715,7.68,7.715,13.389c0,8.535-6.937,15.487-15.474,15.487 c-8.535,0-15.458-6.952-15.458-15.487c0-5.703,3.14-10.698,7.728-13.382c0.534-0.312,0.862-0.889,0.862-1.505V5.322 c0-0.583-0.289-1.126-0.77-1.447c-0.488-0.328-1.102-0.382-1.636-0.16C6.035,7.356,0,15.927,0,25.923C0,39.218,10.771,50,24.066,50 c13.295,0,24.041-10.782,24.041-24.077C48.107,15.927,42.065,7.356,33.335,3.715L33.335,3.715z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOff);
export default __webpack_public_path__ + "static/media/off.7180d1b186c79527ca4221cfd624da33.svg";
export { ForwardRef as ReactComponent };